import { Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import Formulario from "./components/formulario/Formulario";
import Politica from "./components/politica/Politica";
import {VOLVER} from "../../components/iconsSVG/IconsSVG.jsx";

const FormularioPage = () => {
  return (
    <>
      <div className="m-0 p-0 d-flex justify-content-end">
        <Link to="/buscador" className="btn m-0 p-0 me-3 btn-volver text-end">
          <VOLVER strokeWidth={1.5} width={"24px"} height={"16px"}/>{" "} VOLVER A CONSULTA BOPI
        </Link>
      </div>
      <Container className="espacios-generales">
        <Row className="mt-5 p-3">
          <Col xs={0} md={2}></Col>
          <Col xs={12} md={8}>
            <h2 style={{ fontSize: '1.5em' }}>Suscripción al Boletín Oficial de la Propiedad Industrial</h2>
            {/* <p>
              Para poder recibir por correo electrónico los tomos del Boletín Oficial
              de la Propiedad Industrial en formato PDF, necesitamos algunos datos
              personales:
            </p> */}
            <Formulario />
            {/* <br />
            <br />
            <Politica />
            <br />
            <br /> */}
          </Col>
          <Col xs={0}  md={2}></Col>
        </Row>
      </Container>
    </>
  );
};

export default FormularioPage;
